import { fetchFunction } from '../../../../../api/config';

//thoughts: use this config for the 4 data queries on the delivery log (deviceLocations, stopTasks, washTasks, tripEvents)
//auto refresh these 4 queries after 5 mins.
//invalidate after when modal closed, which is the cacheTime: 0
export const deliveryLogQueryConfig = {
    queries: {
        //sorting is done in api
        queryFnNoSort: async (key: string) => {
            return fetchFunction(key).then(({ data }) => data);
        },
        staleTime: 5 * 60 * 1000, //5mins
        cacheTime: 0,
        refetchInterval: 5 * 60 * 1000, //5mins
    }
};
